var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15321 0.465032C4.17338 0.380979 4.24855 0.321716 4.33499 0.321716H4.78526C4.84353 0.321716 4.89847 0.348889 4.93384 0.395202L6.21587 2.07408L6.39676 2.37557C6.41559 2.40695 6.42119 2.44454 6.41231 2.48005L5.72514 5.22873L3.60791 2.73712L4.15321 0.465032Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60794 2.73712L5.72517 5.22873L3.21131 15.4775C2.90367 16.7317 1.77928 17.6137 0.487902 17.6137H0.118906C0.0583678 17.6137 0.0137995 17.557 0.0280677 17.4982L3.60794 2.73712Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6496 6.7908C6.68496 6.83715 6.73999 6.86441 6.79829 6.86441H9.64975C9.72702 6.86441 9.77093 6.77602 9.72426 6.71443L4.98118 0.457707C4.91593 0.371863 4.81432 0.32145 4.7065 0.321438L4.46206 0.321411C4.30137 0.321394 4.16193 0.432302 4.1258 0.588879L3.85559 3.12555L6.6496 6.7908Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8044 17.6138H16.2307C15.3536 17.6138 14.5269 17.2034 13.9968 16.5046L8.13269 8.77557H11.2612L17.8788 17.4637C17.9257 17.5252 17.8818 17.6138 17.8044 17.6138Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35836 0.471281C7.31181 0.409712 7.35572 0.321411 7.43293 0.321411H12.7355V0.322275C12.7628 0.321852 12.7901 0.321639 12.8174 0.321639C15.676 0.321639 17.9933 2.63895 17.9933 5.4975C17.9933 8.35603 15.676 10.6733 12.8174 10.6733C12.7901 10.6733 12.7628 10.6731 12.7355 10.6727L8.28902 10.6726C7.70434 10.6726 7.15328 10.399 6.79984 9.93328L5.83925 8.66737C5.79249 8.60578 5.83655 8.51726 5.9139 8.51739L12.7355 8.53115V8.53172C12.7619 8.53243 12.7884 8.53275 12.8149 8.53275C14.4927 8.53275 15.8527 7.17273 15.8527 5.49496C15.8527 3.81722 14.4927 2.45714 12.8149 2.45714C12.7884 2.45714 12.7619 2.45748 12.7355 2.45817V2.45555H8.90623C8.87691 2.45555 8.84933 2.44182 8.83166 2.41848L7.35836 0.471281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArTag);
export default __webpack_public_path__ + "static/media/arTag.24254db22c097aa7d82ca964846e29cf.svg";
export { ForwardRef as ReactComponent };